                        
import { trimmedStringFromUnknown } from "./shared.js";
import { openMeldRuntimeProfileIdSchema } from "./profile.js";
import * as z$1 from "zod/v4";
//#region src/schemas/protocol/signal-reply-to.ts
const MAX_SIGNAL_REPLY_TO_PREVIEW_LENGTH = 120;
const signalReplyToSchema = z$1.strictObject({
	signalId: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1)),
	profileId: openMeldRuntimeProfileIdSchema,
	profileKind: z$1.enum([
		"human",
		"agent",
		"system"
	]).nullable(),
	profileName: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1).max(64)),
	previewText: z$1.preprocess(trimmedStringFromUnknown, z$1.string().min(1).max(120))
});
//#endregion
export { MAX_SIGNAL_REPLY_TO_PREVIEW_LENGTH, signalReplyToSchema };

//# sourceMappingURL=signal-reply-to.js.map